import { middlewareService } from '../../../../../shared/service';

export const festGoalsService = {
    getShoppingGoals,
    getGoalDetails,
    getMTM,
    getShopingStats,
    validateGoal,
    redeemGoalAmount
};

function getShoppingGoals() {
    let url = "/shoppingGoal/getGoals";
    let festId = process.env.REACT_APP_FESTIVAL_ID ? process.env.REACT_APP_FESTIVAL_ID : "amazon01";
    let payload = {
        festId: festId
    }
    return middlewareService.postApiData(url, payload)
        .then(response => response)
}

function getGoalDetails(payload) {
    let url = "/shoppingGoal/getGoalDetails";

    return middlewareService.postApiData(url, payload)
        .then(response => response)
}

function getMTM(payload) {
    let url = "/shoppingGoal/mtm";

    return middlewareService.postApiData(url, payload)
        .then(response => response)
}

function getShopingStats(payload) {
    let url = "/shoppingGoal/stats";

    return middlewareService.postApiData(url, payload)
        .then(response => response)
}

function validateGoal(payload) {
    let url = "/shoppingGoal/validate"
    
    return middlewareService.postApiData(url, payload)
        .then(response => response)
}


function redeemGoalAmount(amount,goalId) {
    let url = "/instaRedeem/redeem"
    let festId = process.env.REACT_APP_FESTIVAL_ID ? process.env.REACT_APP_FESTIVAL_ID : "amazon01";
    let payload = {
        amount: amount,
        festId: festId,
        goalId: goalId
    }
    return middlewareService.postApiData(url, payload)
        .then(response => response)
}